import { IPeopleDecision } from "../../../models/models";

export const INIT_REPRESENTATIVE_INFO: IPeopleDecision = {
  chucVu: null,
  chucVuId: "",
  chucVuText: "",
  id: "",
  name: "",
  isDefault: false
}